import { ReactElement } from 'react';
import { OpenInNew } from '@mui/icons-material';
import { Link, Typography } from '@mui/material';

import styles from 'features/app-information/views/components/external-link.component.module.scss';

interface IProps {
  link: string;
  linkTranslationKey: string;
  linkCompanyTranslationKey: string;
}

function ExternalLink(props: Readonly<IProps>): ReactElement {
  return (
    <Link className={styles.externalLinkContainer} target="_blank" href={props.link} rel="noopener" underline="none">
      <OpenInNew accentHeight={18} />
      <div className={styles.linkText}>
        <Typography variant="subtitle2">{props.linkTranslationKey}</Typography>
        <Typography variant="subtitle1">{props.linkCompanyTranslationKey}</Typography>
      </div>
    </Link>
  );
}

export default ExternalLink;
